import React, { useState } from 'react';
import { connect } from 'react-redux';
import axios from 'axios';

import { Form, InputGroup, InputGroupAddon, Button, Input } from 'reactstrap';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch } from '@fortawesome/free-solid-svg-icons';

import Autosuggest from 'react-autosuggest';
import './SearchInput.scss';
import config from '../../config';

const SearchInput = props => {
  const { i18n } = props;
  const { locale, translations } = i18n || {};
  const text = translations[locale];

  const [value, setValue] = useState('');
  const [suggestions, setSuggestions] = useState([]);

  const getSuggestionValue = suggestion => {
    return suggestion.keyword;
  };

  const renderSuggestion = suggestion => {
    return <span>{suggestion.keyword}</span>;
  };

  const onChange = (event, { newValue, method }) => {
    setValue(newValue);
  };

  const fetchSuggestions = async value => {
    try {
      // fetch data from a url endpoint
      const response = await axios({
        url: config.autoCompletePath,
        params: {
          q: value,
          language: locale,
        },
        timeout: 30000,
        method: 'get',
        responseType: 'json',
      });
      return response;
    } catch (error) {
      console.log('error', error);
      // appropriately handle the error
    }
  };

  const onSuggestionsFetchRequested = async ({ value }) => {
    const reponse = await fetchSuggestions(value);
    const list = ((reponse || {}).data || {}).suggestions || [];
    setSuggestions(list);
  };

  const onSuggestionsClearRequested = () => {
    setSuggestions([]);
  };

  const onSubmit = e => {
    e.preventDefault();
    if (props.onSubmit && value) {
      props.onSubmit(value);
    }
    if (!value) {
      alert(text.search.validation);
    }
  };

  const renderInputComponent = inputProps => (
    <Form onSubmit={onSubmit}>
      <InputGroup>
        <Input {...inputProps} type="Search" className="border-right-0" />
        <InputGroupAddon addonType="append">
          <Button outline color="primary" className="border border-left-0" type="Submit">
            <FontAwesomeIcon icon={faSearch} />
          </Button>
        </InputGroupAddon>
      </InputGroup>
    </Form>
  );

  const inputProps = {
    placeholder: text.search.placeholder,
    value,
    onChange,
  };

  return (
    <Autosuggest
      suggestions={suggestions}
      onSuggestionsFetchRequested={onSuggestionsFetchRequested}
      onSuggestionsClearRequested={onSuggestionsClearRequested}
      getSuggestionValue={getSuggestionValue}
      renderSuggestion={renderSuggestion}
      renderInputComponent={renderInputComponent}
      inputProps={inputProps}
    />
  );
};

const mapStateToProps = state => ({
  i18n: state.i18n,
});

const connectStore = connect(mapStateToProps, null, null, {
  pure: true,
})(SearchInput);

export { SearchInput as SearchInputComponent }; // <- For component Unit Test
export default connectStore;
